document.addEventListener("DOMContentLoaded", function() {
  
  const startDate = new Date('2024-12-19T11:00:00');
  const endDate = new Date('2024-12-27T11:00:00');
  const now = new Date();
  
  if (now >= startDate && now < endDate) {
    const elements1 = document.querySelectorAll('.m-menu-mobile__item.m-menu-mobile__item--no-submenu');
    const elements2 = document.querySelectorAll('.m-menu__item');
    
    elements1.forEach(el => el.style.display = 'block');
    elements2.forEach(el => el.style.display = 'block');
  }
});
